"use client"
import { trackingDetails } from "@/api/getOtherFormDetails";
import { getIpJSONData } from "@/context/ip.storage.utils";
import { getGlobalStateValue } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { StorageService } from "@/helpers/storage.service";

const leadSquareApiCall = (form: any, payload: any) =>
  fetch("/api/salesforce.com/lead-create-new", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ipstack: getIpJSONData(),
      form: { ...form, ...payload },
      meta: {
        ...trackingDetails(),
        utm_medium: trackingDetails()?.utm_medium || "request_a_callback",
      },
    }),
  });
const leadSquareApiCallCert = (form: any, payload: any = {}) =>
  fetch("/api/salesforce.com/lead-creation-certification", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ipstack: getIpJSONData(),
      form: { ...form, ...payload },
      meta: {
        ...trackingDetails(),
        utm_medium: trackingDetails()?.utm_medium || "request_a_callback",
      },
    }),
  });

export const leadSquareApiCallFlow = (form: any, extraPayload: any = {}) => {
  const tracking = trackingDetails();
  return new Promise((resolve, reject) => {
    const connectCounsellorApiCall = fetch("/api/connect-counsellor", {
      method: "POST",
      body: JSON.stringify({
        ipstack: getIpJSONData(),
        form,
        status: true,
        meta: {
          ...tracking,
          utm_medium: tracking?.utm_medium || "request_a_callback",
        },
      }),
    });

    function getEvent(event: any) {
      StorageService.set("mFitlerKeyDetails", event.detail);
    }

    Promise.all([
      leadSquareApiCall(form, { Custom5: "False", ...extraPayload }),
      connectCounsellorApiCall,
    ])
      .then((responses) => Promise.all(responses.map((response) => response.json())))
      .then((d) => {
        const resp = d[0]?.response || {};

        if (d?.[0]?.success) {
          try {
            window?.webengage?.track("ISAT Registration Link", {
              "Registration Link": resp?.TestURL || "",
            });
            pushToDataLayer({ LSQ_ID: resp?.ProspectId });
            pushToDataLayer({
              event: "MFilter_OTP_Verified_New",
              LSQ_ID: resp?.ProspectId,
            });
            document.addEventListener("mfilterit:botDetect", getEvent);
            StorageService.set("LSQ_ID", resp?.ProspectId);

            pushToDataLayer({
              event: "lead_submit",
              cta_text: "Submit",
              lead_starting_cta: "Register Now",
              lead_starting_url: window.location.href || "NA",
              lead_id: resp?.ProspectId,
              section_name: getGlobalStateValue("parentSection") || "NA",
              status: "success",
              error_message: "NA",
              lead_type: "lead_submit_1",
              page_type: getGlobalStateValue("pageType"),
              email_id: form.email,
              page_url: window?.location?.href || "NA",
            });

            window?.webengage?.track("Lead Form Filled", {
              "Student Nationality": form.countryCode == "+91" ? "National" : "International",
              "First Name": form.name,
              "Phone Number": form.countryCode + form.phone,
              "Email ID": form.email,
              "Form Type": "Apply",
              "Section Name": getGlobalStateValue("parentSection") || "",
              "Application URL": resp?.URL || "",
            });

            window?.webengage?.user?.login(resp?.ContactId);
            window?.webengage?.user?.setAttribute("we_email", form.email);
            window?.webengage?.user?.setAttribute("we_first_name", form.name);
            window?.webengage?.user?.setAttribute("we_phone", form.countryCode + form.phone);
          } catch (gaErr) {
            console.error("GA / WebEngage error:", gaErr);
          }
          resolve(resp);
        } else {
          const errorMessage = "Error occurred.";
          pushToDataLayer({
            event: "lead_submit",
            cta_text: "Submit",
            lead_starting_cta: "Register Now",
            lead_starting_url: window.location.href || "NA",
            lead_id: resp?.ProspectId,
            section_name: "hero_banner",
            status: "fail",
            error_message: errorMessage,
            lead_type: "lead_submit_1",
            page_type: getGlobalStateValue("pageType"),
            email_id: form.email,
            page_url: window?.location?.href || "NA",
          });
          reject(new Error(errorMessage));
        }
      })
      .catch((e) => {
        pushToDataLayer({
          event: "lead_submit",
          cta_text: "Submit",
          lead_starting_cta: "Register Now",
          lead_starting_url: window.location.href || "NA",
          lead_id: "NA",
          section_name: "hero_banner",
          status: "fail",
          error_message: e?.message || String(e),
          lead_type: "lead_submit_1",
          page_type: getGlobalStateValue("pageType"),
          email_id: form.email,
          page_url: window?.location?.href || "NA",
        });
        reject(e);
      });
  });
};

export const leadSquareApiCallBothFlow = (
  degreeForm: any,
  certForm: any,
  extraDegreePayload: any = {},
  extraCertPayload: any = {}
) => {
  const tracking = trackingDetails();
  return new Promise((resolve, reject) => {
    const connectCounsellorApiCall = fetch("/api/connect-counsellor", {
      method: "POST",
      body: JSON.stringify({
        ipstack: getIpJSONData(),
        form: degreeForm,
        status: true,
        meta: {
          ...tracking,
          utm_medium: tracking?.utm_medium || "request_a_callback",
        },
      }),
    });

    function getEvent(event: any) {
      StorageService.set("mFitlerKeyDetails", event.detail);
    }

    Promise.all([
      leadSquareApiCall(degreeForm, {  ...extraDegreePayload }),
      leadSquareApiCallCert(certForm,{  ...extraCertPayload }),
      connectCounsellorApiCall,
    ])
      .then((responses) => Promise.all(responses.map((response) => response.json())))
      .then((d) => {
        const degreeRes = d[0] || {};
        const certRes = d[1] || {};
        const resp = degreeRes?.response || {};
        const certResp = certRes?.response || {};

        if (degreeRes?.success || certRes?.success) {
          try {
            window?.webengage?.track("ISAT Registration Link", {
              "Registration Link": resp?.TestURL || "",
            });
            pushToDataLayer({ LSQ_ID: resp?.ProspectId });
            pushToDataLayer({
              event: "MFilter_OTP_Verified_New",
              LSQ_ID: resp?.ProspectId,
            });
            document.addEventListener("mfilterit:botDetect", getEvent);
            StorageService.set("LSQ_ID", resp?.ProspectId);

            pushToDataLayer({
              event: "lead_submit",
              cta_text: "Submit",
              lead_starting_cta: "Register Now",
              lead_starting_url: window.location.href || "NA",
              lead_id: resp?.ProspectId,
              section_name: getGlobalStateValue("parentSection") || "NA",
              status: "success",
              error_message: "NA",
              lead_type: "lead_submit_1",
              page_type: getGlobalStateValue("pageType"),
              email_id: degreeForm.email,
              page_url: window?.location?.href || "NA",
            });

            window?.webengage?.track("Lead Form Filled", {
              "Student Nationality": degreeForm.countryCode == "+91" ? "National" : "International",
              "First Name": degreeForm.name,
              "Phone Number": degreeForm.countryCode + degreeForm.phone,
              "Email ID": degreeForm.email,
              "Form Type": "Apply",
              "Section Name": getGlobalStateValue("parentSection") || "",
              "Application URL": resp?.URL || "",
            });

            window?.webengage?.user?.login(resp?.ContactId);
            window?.webengage?.user?.setAttribute("we_email", degreeForm.email);
            window?.webengage?.user?.setAttribute("we_first_name", degreeForm.name);
            window?.webengage?.user?.setAttribute("we_phone", degreeForm.countryCode + degreeForm.phone);
          } catch (gaErr) {
            console.error("GA / WebEngage error:", gaErr);
          }
          resolve({ degree: resp, cert: certResp });
        } else {
          const errorMessage = "Error occurred.";
          pushToDataLayer({
            event: "lead_submit",
            cta_text: "Submit",
            lead_starting_cta: "Register Now",
            lead_starting_url: window.location.href || "NA",
            lead_id: resp?.ProspectId,
            section_name: "hero_banner",
            status: "fail",
            error_message: errorMessage,
            lead_type: "lead_submit_1",
            page_type: getGlobalStateValue("pageType"),
            email_id: degreeForm.email,
            page_url: window?.location?.href || "NA",
          });
          reject(new Error(errorMessage));
        }
      })
      .catch((e) => {
        pushToDataLayer({
          event: "lead_submit",
          cta_text: "Submit",
          lead_starting_cta: "Register Now",
          lead_starting_url: window.location.href || "NA",
          lead_id: "NA",
          section_name: "hero_banner",
          status: "fail",
          error_message: e?.message || String(e),
          lead_type: "lead_submit_1",
          page_type: getGlobalStateValue("pageType"),
          email_id: degreeForm.email,
          page_url: window?.location?.href || "NA",
        });
        reject(e);
      });
  });
};
